import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _filter from 'lodash/filter';
import moment from 'moment';

function BrowseCityCtrl($rootScope, $scope, $state, $stateParams, $location, $timeout, partnerService,
  modalService, metaTagService, eventService, venueService, utilsService, loggerService, membershipService, jsSdkCuratedList, imgix) {
  $scope.loading = {
    city: true,
    seasonal: true,
    featured: true,
    lists: true,
    venues: true,
    events: true
  };

  $scope.imgix = function(src) {
    const options = {
      width: 1200,
      height: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };
  $scope.curatedLists = [];
  $scope.curatedListLimit = 6;

  metaTagService.set({
    title: 'Browse Tablelist venues and events',
    description: 'Browse Tablelist venues and events'
  });

  const seasonalLists = [
    // // BOSTON - development
    // 'f1305df4e52929c9',
    //
    // // Production
    // // Boston
    // 'b698d874e188395b',
    // // Chicago
    // '502c30150c54ccb1',
    // // Nyc
    // '27964c082f63edf6',
    // // DC
    // 'bc15909d9d9ef303',
    // // Foxwoods
    // '5bbb6b3ce37a6270',
    // // LA
    // 'da9ef701a554749d',
    // // Miami
    // 'd6365d210b4784dc',
    // // Phl
    // '8a781784484defd8',
    // // SF
    // '01b19051fa620e9a',
    // // Vegas
    // '8b4fb520b01a6684'
  ];

  $scope.onlySeasonal = function(list) {
    return _includes(seasonalLists, list.id);
  };

  $scope.noSeasonal = function(list) {
    return !_includes(seasonalLists, list.id);
  };

  $scope.citiesPromise
    .then(() => {
      const city = $stateParams.city;

      if (!city) {
        $state.go('app.browse.city', {
          city: utilsService.defaultCitySlug()
        });

        return;
      }

      _loadFeatured(city);
      _loadLists(city);

      $scope.setCity(city, () => {
        $scope.loading.city = false;

        metaTagService.set({
          title: `${$scope.city.displayName} - Browse Tablelist lists, events and venues`,
          description: 'Browse Tablelist lists, events and venues',
          facebookImage: _get($scope, ['city', 'primaryImage', 'xlarge'])
        });

        _loadEvents();
        _loadVenues();
      });
    })
    .catch(err => {
      loggerService.error(err);
    });

  $scope.changeCity = function() {
    const city = $scope.selectedCity;

    console.log('changeCity', city);

    if (city.slugName === $stateParams.city) return;

    utilsService.link(`/${city.slugName}/discover/`);
  };

  function _loadFeatured(city) {

    $scope.featured = [];

    const options = {
      type: ['FEATURED'],
      maxMembershipLevel: membershipService.membershipLevel(),
      slug: true
    };

    const promise = jsSdkCuratedList.listByCityId(city, options);

    promise.then(function(resp) {
      if (!resp || !resp[0] || !resp[0].id) {
        $scope.loading.featured = false;
        return;
      }

      jsSdkCuratedList.readById(resp[0].id, {
        items: true
      }).then(resp2 => {
        $scope.loading.featured = false;
        $scope.featured = resp2.items;
      }, error);
    }, error);
  }

  function _loadLists(city) {
    const options = {
      type: ['REGULAR'],
      slug: true
    };

    jsSdkCuratedList.listByCityId(city, options)
      .then(resp => {
        resp = _filter(resp, function(list) {
          return list.itemCount > 0;
        });

        $scope.curatedLists = resp;
        $scope.loading.lists = false;
        $scope.loading.seasonal = false;
      }, error);
  }

  function _loadEvents() {
    $scope.events = [];

    const options = {
      fields: 'date,seoPathname,favoriteCount,name,images,venue(name,seoPathname,location.address),special,tags',
      cityId: $scope.city.id,
      sort: 'date',
      limit: 3,
      start: moment().toDate().getTime(),
      end: moment().add(7, 'days').toDate().getTime()
    };

    eventService.listForCity(options).then(function _success(response) {
      $scope.events = response;
      $scope.loading.events = false;

      $timeout(function() {
        $rootScope.$broadcast('eventsLoaded');
      });
    }, error);
  }

  function _loadVenues() {
    const options = {
      cityId: $scope.city.id,
      fields: 'name, seoPathname, tags, images, featured, rating, favoriteCount',
      limit: 3
    };

    venueService.listForCity(options).then(function success(response) {
      $scope.venues = response;
      $scope.loading.venues = false;

      $timeout(function() {
        $rootScope.$broadcast('venuesLoaded');
      });

    }, error);
  }

  $scope.sortVenues = function(item) {
    return item.favoriteCount * -1;
  };

  function error(message) {
    loggerService.error(message);
  }

  $scope.scrollTo = function(id) {
    utilsService.scrollTo(id, 80);
  };
}

BrowseCityCtrl.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$stateParams',
  '$location',
  '$timeout',
  'partnerService',
  'modalService',
  'metaTagService',
  'tl.event.service',
  'tl.venue.service',
  'utilsService',
  'loggerService',
  'membershipService',
  'jsSdk.curatedList',
  'jsSdk.imgix'
];

export default BrowseCityCtrl;



// WEBPACK FOOTER //
// ./src/components/browseCity/browseCityCtrl.js